// extracted by mini-css-extract-plugin
module.exports = {"switchDiv":"components-base-Switch-Switch__switchDiv--1Vawe"};